import { render, staticRenderFns } from "./ProductFlagToggle.vue?vue&type=template&id=f4a4bdc2&"
import script from "./ProductFlagToggle.vue?vue&type=script&lang=js&"
export * from "./ProductFlagToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports